import { render, staticRenderFns } from "./ConversationDetail.vue?vue&type=template&id=4a2d402e&scoped=true"
import script from "./ConversationDetail.vue?vue&type=script&lang=js"
export * from "./ConversationDetail.vue?vue&type=script&lang=js"
import style0 from "./ConversationDetail.vue?vue&type=style&index=0&id=4a2d402e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2d402e",
  null
  
)

export default component.exports